import { render } from "./stronaLogowania.vue?vue&type=template&id=2111bc6d"
import script from "./stronaLogowania.vue?vue&type=script&lang=js"
export * from "./stronaLogowania.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__